import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-skeleton',
  templateUrl: './table-skeleton.component.html',
  standalone: false
})
export class TableSkeletonComponent {
  /** How many placeholder rows to draw. Match roughly what fits on screen. */
  @Input() rows = 6;
  /** Column count of the table being loaded, so the placeholder lines up. */
  @Input() columns = 4;

  get rowList(): number[] {
    return Array.from({ length: Math.max(1, this.rows) }, (_, i) => i);
  }
  get colList(): number[] {
    return Array.from({ length: Math.max(1, this.columns) }, (_, i) => i);
  }
  /** Narrow the last column a little so the rows do not read as a solid block. */
  barWidth(col: number): string {
    return col === this.columns - 1 ? '40%' : '70%';
  }
}
